/**
 * Models Index
 * Hier komt alles samen
 */

// Product spul
export type {
  Grade,
  SustainabilityFactor,
  Product,
  ProductDisplay,
  ProductDatabaseRow,
} from './Product';

export { GRADE_COLORS } from './Product';

// Favorieten
export type {
  Favorite,
  FavoritesList,
} from './Favorite';

// Foutjes
export type {
  ErrorType,
  AppError,
} from './AppError';

export { maakApplicatieFout } from './AppError';

// Navigatie troep
export type {
  RootStackParamList,
  HomeStackParamList,
  SearchStackParamList,
  FavoritesStackParamList,
} from './Navigation';
